<template>
    <actions-menu v-model:dialogEdit="EditDialog" v-model:dialogDelete="DeleteDialog" :Id="Id" />
    <dialogDelete :title="$t('suppliers.locationTab.location')" :yes="deletePickupPointLocation" v-model="DeleteDialog" />
    <v-dialog v-model="EditDialog" v-if="EditDialog">
        <v-card width="1000px" class="py-2" style="border-radius: 12px;">
            <h1 class="text-center dialog-title"> {{ $t('suppliers.locationTab.edit') }}</h1>
            <div v-if="loader" style="height: 250px; line-height: 250px;">
                <v-progress-circular indeterminate :size="50"></v-progress-circular>
            </div>
            <div v-else class="row ma-4">
                <div class="col-7 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('suppliers.locationTab.locationName') }}
                            <span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="NameEdit" variant="outlined" hide-details persistent-placeholder
                            name="NameEdit" id="NameEdit"></v-text-field>
                        <span class='warningHint' id="WarningMsgName">{{ msg.NameEdit }}</span>
                    </div>
                </div>

                <div class="col-5 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">
                            {{ $t('suppliers.locationTab.contactNumber') }}
                            <span class="red">*</span>
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="contactNumber" variant="outlined" hide-details persistent-placeholder
                            name="contactNumber" id="contactNumber"></v-text-field>
                        <span class='warningHint' id="WarningMsgName">{{ msg.contactNumber }}</span>
                    </div>
                </div>

                <div class="col-12 justify-content-start mt-2" style="line-height: 100%;">
                    <p><strong>Adresse :</strong> {{ AddressEdit }}</p>
                    <p><strong>Ville :</strong> {{ CityEdit }}</p>
                    <p><strong>Pays :</strong> {{ CountryEdit }}</p>
                    <p><strong>Code Postal :</strong> {{ PostalCodeEdit }}</p>
                </div>

                <div class="col-12 justify-content-centre align-centre mt-2">
                    <div class="row">
                        <l-map :zoom="13" :center="markerLatLng" style="height: 300px; width: 100%;"
                            @click="onMapClick">
                            <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
                            <l-marker :lat-lng="markerLatLng" :draggable="true" @update:lat-lng="onMarkerDrag" />
                        </l-map>
                    </div>
                </div>
            </div>
            <card-actions :yes="validateFormEdit" v-model:no="EditDialog" :yesDisable="loader || loaderGeoInfo" width="300px"
                :yesTitle="$t('suppliers.save')" />
        </v-card>
    </v-dialog>
</template>
<script>
import cardActions from "@/genericComponent/cardActions.vue"
import actionsMenu from "@/genericComponent/actionsMenu.vue"
import dialogDelete from "@/genericComponent/dialogDelete.vue"
import { editPickupPointLocation, deletePickupPointLocation } from "@/api/index";
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet'

export default {
    mounted() {
        this.markerLatLng = [this.PickupPoint.latitude, this.PickupPoint.longitude]
    },
    components: {
        actionsMenu, dialogDelete, cardActions, LMap,
        LTileLayer,
        LMarker,
    },
    name: "PickupPointLocationEditMenu",
    props: {
        getPickupPointLocationlist: {},
        PickupPoint: {
            type: Object,
            required: true,
        },
        Id: {}
    },
    data() {
        return {
            DeleteDialog: false,
            msg: [],
            EditDialog: false,
            NameEdit: this.PickupPoint.locationName,
            AddressEdit: this.PickupPoint.address,
            PostalCodeEdit: this.PickupPoint.postalCode,
            CityEdit: this.PickupPoint.city,
            CountryEdit: this.PickupPoint.country,
            idPickupPointLocation: this.PickupPoint.idPickupPointLocation,
            validationButton: false,
            Name: "",
            loader: false,
            loaderGeoInfo: false,
            item: null,
            lat: 36.81897,
            lng: 10.16579,
            center: null,
            markerLatLng: [this.PickupPoint.latitude, this.PickupPoint.longitude],
            url: this.PickupPoint.url,
            tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            tileAttribution: '&copy; OpenStreetMap contributors',

            country: ''
        };
    },
    watch: {
        EditDialog() {
            this.msg = []
            this.NameEdit = this.PickupPoint.locationName
            this.contactNumber = this.PickupPoint.contactNumber
            this.AddressEdit = this.PickupPoint.address
            this.PostalCodeEdit = this.PickupPoint.postalCode
            this.CityEdit = this.PickupPoint.city
            this.CountryEdit = this.PickupPoint.country
            this.idPickupPointLocation = this.PickupPoint.idPickupPointLocation
        },
    },
    methods: {
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        deletePickupPointLocation() {
            this.DeleteDialog = false;
            deletePickupPointLocation(this.idPickupPointLocation)
                .then(() => {
                    this.getPickupPointLocationlist();
                    this.ActiveDeletedSnackBar();

                }).catch(() => {
                    this.ActiveWarningSnackBar()
                });
        },
        editPickupPointLocation() {
            editPickupPointLocation({
                idPickupPointLocation: this.idPickupPointLocation,
                locationName: this.NameEdit,
                contactNumber: this.contactNumber,
                address: this.AddressEdit,
                postalCode: this.PostalCodeEdit,
                city: this.CityEdit,
                country: this.CountryEdit,
                url: this.url
            })
                .then(() => {
                    this.getPickupPointLocationlist();
                    this.ActiveSavedSnackBar()
                })
                .catch(() => {
                    this.ActiveWarningSnackBar();
                });
        },
        validateFormEdit() {
            if (!(this.NameEdit) || (this.NameEdit).length == 0) {
                this.msg['NameEdit'] = this.$t("warningInput.isrequired", { itm: this.$t("suppliers.locationTab.locationName") });
            }
            else {
                this.msg['NameEdit'] = '';
            }

            if (!(this.contactNumber) || (this.contactNumber).length == 0) {
                this.msg['contactNumber'] = this.$t("warningInput.isrequired", { itm: this.$t("suppliers.locationTab.contactNumber") });
            }
            else {
                this.msg['contactNumber'] = '';
            }
            

            if (
                this.msg["NameEdit"] == "" &&
                this.msg["contactNumber"] == ""
            ) {
                this.editPickupPointLocation();
                this.EditDialog = false;
            }
        },
        onMapClick(e) {
            this.markerLatLng = [e.latlng.lat, e.latlng.lng]
            this.url = this.generateGoogleMapsUrl(e.latlng.lat, e.latlng.lng)
            this.reverseGeocode(e.latlng.lat, e.latlng.lng)
        },
        onMarkerDrag(newLatLng) {
            this.markerLatLng = [newLatLng.lat, newLatLng.lng]
            this.url = this.generateGoogleMapsUrl(newLatLng.lat, newLatLng.lng)
        },
        generateGoogleMapsUrl(lat, lng) {
            return `https://www.google.com/maps/@${lat},${lng}`;
        },
        getCurrentPosition() {
            if (!navigator.geolocation) {
                alert("La géolocalisation n'est pas supportée par votre navigateur.")
                return
            }
            navigator.geolocation.getCurrentPosition(
                position => {
                    const { latitude, longitude } = position.coords
                    this.center = [latitude, longitude]
                    this.markerLatLng = [latitude, longitude]
                    this.zoom = 15

                    this.item.latitude = latitude
                    this.item.longitude = longitude
                    this.item.url = this.generateGoogleMapsUrl(latitude, longitude)

                    this.loader = false;
                },
            )
        },
        async reverseGeocode(lat, lon) {
            try {
                this.loaderGeoInfo = true;

                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
                )
                const data = await response.json()
                const address = data.address

                this.CityEdit = address.city || address.town || address.village || address.state || '';
                this.CountryEdit = address.country || '';
                this.PostalCodeEdit = address.postcode || '';
                this.AddressEdit = data.display_name || ''
            } catch (err) {
                console.error('Erreur reverse geocoding :', err)
            } finally {
                this.loaderGeoInfo = false;
            }
        }
    }
};
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-dialog .v-card {
    width: 400px;
    border-radius: 12px;
    background-color: #ffffff;
}

.v-card-title {
    font-family: inter;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #0d0849;
    margin-left: 40px;
    margin-top: -30px;
    cursor: pointer;
}

.v-card-text {
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
}


.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.dialog-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0px;
    text-align: left;
}
</style>